<h1 multilang mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <mat-form-field class="textarea" appearance="fill">
        <mat-label multilang>Extra info</mat-label>
        <textarea matInput placeholder="Ihre message" rows="10" [(ngModel)]="data.message"></textarea>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <div style="display: flex;width: 100%;justify-content: flex-end;">
        <button mat-button (click)="onNoClick()">Abrechen</button>
        <button mat-flat-button color="primary" (click)="onSaveClick()">Speichern</button>
    </div>
</div>